import React from "react";
import IconClose from "../../Resources/svg/Icons/IconClose";

interface IBasemModal {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  title: string;
  width?: string;
  prov?: any;
}

export const BaseModal = ({
  open,
  handleClose,
  children,
  title,
  prov,
  width,
}: IBasemModal) => {
  return (
    <div
      className={
        "modal-basic modal-container is-midle-error" + (open ? " is-open" : "")
      }
    >
      <div
        className={"modal-basic__box"}
        style={{ maxHeight: prov && "770px" }}
      >
        <div className="modal-basic__close" onClick={handleClose}>
          <IconClose />
        </div>
        <div className="modal-basic__body">
          <div className="wrap">
            <div className="modal-basic__inner">
              <h2 className="modal-container__title">{title}</h2>
              <div className="modal-container__body">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
